import type { RouteRecordRaw } from 'vue-router';

// /**
//  * 首页路由配置
//  *
//  * @todo
//  *
//  * 首页的设计包含了过多「采编子系统 - 编辑角色」专用的东西，成为了这个角色的专用首页，问题有如下解决方案（暂时采用了方案2）：
//  *
//  * 1. 挪到采编子系统，替换目前子系统中的工作台，基座的首页空出来等待重新设计
//  * 2. 剔除用户角色权限相关的统计看板模块
//  *
//  * @remarks
//  *
//  * 要挪到采编子系统，需适配微前端子系统路由配置中传递的 `[page='home'/'manage'/'page']` 参数
//  */
// export const home: RouteRecordRaw = {
//   path: '/',
//   name: 'XomHomePage',
//   meta: { page: 'home', safe: true },
//   component: () => import('@/pages/home/index.vue'),
// };

/**
 * 假的平台首页，之所以称之为「假」，是因为在 2025.6 月上线的“首页”无法推广到所有客户，只能针对性开放。
 *
 * 因此，首页的跳转也需要动态化，最好的方案是保持「登录后，从鉴权列表获取第一个子系统做首页的跳转路径」的方案。
 * 这个方案的弊端就是，它会影响整个基座的路由决策。
 *
 * 且这样的一个，需要被权限支配的首页更没有资格占用根部路由路径「/」，根级路由「/」依然需要空出来，等待真正的首页上线。
 */
export const liarHome: RouteRecordRaw = {
  path: '/',
  name: 'XomLiarPage',
  redirect: '/loading',
  meta: { page: 'home', safe: true },
};

export const redirectPage: RouteRecordRaw = {
  path: '/loading',
  name: 'RedirectPage',
  meta: { page: 'page', safe: true },
  component: () => import('@/pages/redirect/index.vue'),
};

/**
 * 旧平台首页路径重定向，防止因用户收藏的首页为旧平台首页，进入系统后被重定向到 `/exception/err_not_found` 页面
 */
export const deprecated: RouteRecordRaw = {
  path: '/bench2131:rest(/?.*)?',
  name: 'XomOldBench',
  meta: { page: 'page' },
  redirect: '/exception/err_csrss_removed',
};

/**
 * 异常缺省页路由配置
 */
export const exception: RouteRecordRaw = {
  path: '/exception:slash(/?)/:code?',
  name: 'XomExceptionPage',
  meta: { page: 'page' },
  component: () => import('@/pages/exception/index.vue'),
};

/**
 * 身分不明的路由重定向中转
 */
export const unidentified: RouteRecordRaw = {
  path: '/:unidentified(.*)',
  name: 'XomUnidentifiedInterceptor',
  meta: { page: 'page' },
  redirect: '/exception/err_not_found',
};
